export default __webpack_public_path__ + "static/media/Russian.db3a5733.mp3";